
export default function Chip({color, size, opacity, style}){

    const s = (size || 20) + 'px';

    const css = {
        width: s,
        minWidth: s,
        height: s,
        minHeight: s,
        backgroundColor: color || 'grey',
        opacity: opacity || 1,
        borderRadius: '50%'
    };

    Object.assign(css, style);

    return <div style={css}></div>
}